"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tag", {
    enumerable: true,
    get: function() {
        return Tag;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var baseStyle = {
    container: {
        bg: "background-action-default",
        color: "text-secondary",
        border: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
        borderRadius: "0.375rem",
        _hover: {
            backgroundColor: "background-action-hover"
        },
        _focus: {
            boxShadow: "0 0 0 0.188rem var(--chakra-colors-primary-focus)"
        },
        _active: {
            backgroundColor: "background-action-pressed"
        },
        _disabled: {
            backgroundColor: "background-container-disabled",
            pointerEvents: "none"
        }
    },
    label: {
        color: "text-secondary",
        textStyle: "text-body-medium",
        _disabled: {
            color: "text-disabled"
        }
    },
    leftIcon: {
        textStyle: "text-body-medium",
        margin: 0
    },
    rightIcon: {
        textStyle: "text-body-medium",
        margin: 0
    }
};
var Tag = {
    parts: [
        "container",
        "label",
        "closeButton",
        "leftIcon",
        "rightIcon"
    ],
    baseStyle: baseStyle,
    variants: {
        subtle: baseStyle
    },
    sizes: {
        s: function(param) {
            var theme = param.theme;
            return {
                container: {
                    px: "spacer-tag-x-S",
                    py: "spacer-tag-y-S",
                    gap: "spacer-tag-gap-S"
                },
                label: _object_spread({}, theme.textStyles["text-body-floating-label-medium"]),
                leftIcon: theme.components.Icon.sizes.xs,
                rightIcon: theme.components.Icon.sizes.xs
            };
        },
        m: function(param) {
            var theme = param.theme;
            return {
                container: {
                    px: "spacer-tag-x-M",
                    py: "spacer-tag-y-M",
                    gap: "spacer-tag-gap-M"
                },
                label: _object_spread({}, theme.textStyles["text-body-meta-medium"]),
                leftIcon: theme.components.Icon.sizes.xs,
                rightIcon: theme.components.Icon.sizes.xs
            };
        },
        l: function(param) {
            var theme = param.theme;
            return {
                container: {
                    px: "spacer-tag-x-L",
                    py: "spacer-tag-y-L",
                    gap: "spacer-tag-gap-L"
                },
                label: _object_spread({}, theme.textStyles["text-body-medium"]),
                leftIcon: theme.components.Icon.sizes.s,
                rightIcon: theme.components.Icon.sizes.s
            };
        }
    },
    defaultProps: {
        size: "l"
    }
};
